import moment from "moment";

import type { SpanNode } from "@/types/spans";

// Backend span ids may arrive without leading zeros; stored ids are 16 chars
export const findSpanById = (spans: SpanNode[], spanId: string): SpanNode | undefined => {
  const paddedId = spanId.padStart(16, "0");
  return spans.find(span => span.span_id === paddedId || span.span_id === spanId);
};

export const getTimeAtPosition = ({
  x,
  timelineWidth,
  traceDuration,
  traceStartTime,
  spanData,
}: {
  x: number;
  timelineWidth: number;
  traceDuration: number;
  traceStartTime: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  spanData: any[];
}) => {
  const percentage = (x / timelineWidth) * 100;
  const timeOffset = (percentage / 100) * traceDuration;
  const absoluteTime = traceStartTime + timeOffset;

  // Find the span that started at traceStartTime to get the original string format
  const traceStartSpan = spanData.find(span => new Date(span.start).getTime() === traceStartTime);

  if (traceStartSpan) {
    // Use the same approach as formatDate: parse the original string as UTC, add offset, then convert to local
    const startMoment = moment.utc(traceStartSpan.start);
    const targetMoment = startMoment.clone().add(timeOffset, "milliseconds");

    return {
      absoluteTimeMs: timeOffset,
      wallTime: targetMoment,
    };
  }

  // Fallback to previous method if span not found
  return {
    absoluteTimeMs: timeOffset,
    wallTime: moment.utc(absoluteTime),
  };
};

export const formatDuration = (ms: number): string => {
  if (ms >= 60000) {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.round((ms % 60000) / 1000);
    if (seconds === 0) {
      return `${minutes}m`;
    }
    return `${minutes}m ${seconds}s`;
  } else if (ms >= 1000) {
    return `${(ms / 1000).toFixed(1)}s`;
  }
  return `${Math.round(ms)}ms`;
};

export const formatWallTime = (momentTime: moment.Moment): string =>
  momentTime.local().format("hh:mm:ss.SSS A");

export const calculateTimelineMetrics = (containerWidth: number) => {
  const timelineWidth = (containerWidth * 2) / 3; // Timeline area is right 2/3
  const timelineStartX = containerWidth / 3; // Timeline starts at 1/3 mark

  return {
    timelineWidth,
    timelineStartX,
  };
};
